export const loadSampleUrl = "/sample/loadExcel";
export const loadInventoryUrl = "/inventory/loadExcel";
export const loadInvoiceUrl = "/invoice/loadExcel";
export const loadClientUrl = "/client/loadExcel";
export const loadOrderUrl = "/orders/loadExcel";
export const loadSalesReportUrl = "/sales/loadExcel";



